import React from 'react'
import { connect } from 'react-redux'
import Navigation from 'support/navigation'
import { createIdea } from 'services/create_idea'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'
import ErrorSubmitModal from './ErrorSubmitContainer'
import SuccessSubmitModal from './SucessSubmitContainer'

import { postInnovateIdeaAddBySMEGroups, getInnovateChallengeTaggedIdeaList } from 'services/innovate/idea'


const mapStateToProps = () => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  // description: i18n.t('EXPLORE_IDEA.PUBLISH_CONFIRM'),
  description: 'Are you sure you want to assign Bulk SME to the entire All Ideas List?',
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  console.log("action===,Bulk idea ", ownProps)
  const {challengeKey} = ownProps.ideaBulkSMEAddParams
  return {
    mainButtonAction : ()=>{
      const onSuccess = response => {
        console.log("success== bulk", response)
        // Refresh the tagged idea list to show updated assignments
        if(challengeKey) {
          dispatch(getInnovateChallengeTaggedIdeaList(challengeKey))
        }
        showPopupDialog(<SuccessSubmitModal description='All of your idea lists have been successfully assigned to the SME.' />, dispatch)
        
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data?.error 
            ? `BACKEND_ERRORS.${data?.error?.en}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorSubmitModal description={messageTag} />, dispatch)
      }
      dispatch(postInnovateIdeaAddBySMEGroups(ownProps.ideaBulkSMEAddParams, onFailure ,onSuccess ))
      dispatch(hideDialog())
    }, 

    cancelButtonAction: () => dispatch(hideDialog()),
    
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
